<section class="breadcrumb-wrapper">
  <nav class="breadcrumbs" *ngIf="trail?.length">
    <ul class="breadcrumb-list">
      <li class="breadcrumb" *ngFor="let crumb of trail">
        <a class="crumb" [routerLink]="crumb.route ?? null">{{
          crumb.label
        }}</a>
      </li>
    </ul>
  </nav>
</section>
